import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { WORKGROUP_TAG } from '@constants/ticketMgmt/manageWorkgroup.constants';
interface IWorkgroupSearchForm {
    selectedWorkgroup: Array<any>;
    workgroupChar: string;
    containsTag: string;
    tageValue: string;
}

interface IWorkgroupSearchFormValidation {
    workgroupChange: boolean;
    containsChange: boolean;
    tagChange: boolean;
}

const useWorkgroupSearchFormValidation = (props: IWorkgroupSearchForm) => {
    const intl = useIntl();
    const DEFAULT_SELECT = intl.formatMessage({ id: WORKGROUP_TAG.SELECT });
    const { selectedWorkgroup, workgroupChar, containsTag, tageValue } =
        props || '';
    const INITIAL_VALIDATION_VALUES = {
        workgroupChange: false,
        containsChange: false,
        tagChange: false,
    };
    const VALIDATION = {
        CONTAINS_CHANGE: 'containsChange',
        TAG_CHANGE: 'tagChange',
    };
    const [validation, setValidation] =
        useState<IWorkgroupSearchFormValidation>(INITIAL_VALIDATION_VALUES);
    const [isButtonDisable, setButtonDisable] = useState(false);

    useEffect(() => {
        updateValidationState(containsTag, VALIDATION.CONTAINS_CHANGE);
    }, [containsTag]);

    useEffect(() => {
        updateValidationState(tageValue, VALIDATION.TAG_CHANGE);
    }, [tageValue]);

    useEffect(() => {
        if (workgroupChar.length > 0 && selectedWorkgroup.length > 0) {
            setValidation({
                ...validation,
                workgroupChange: true,
            });
        } else if (
            selectedWorkgroup.length === 0 ||
            workgroupChar.length === 0
        ) {
            setValidation({
                ...validation,
                workgroupChange: false,
            });
        }
    }, [selectedWorkgroup, workgroupChar]);

    useEffect(() => {
        const { workgroupChange, containsChange, tagChange } = validation || '';
        const shouldEnableButton =
           (workgroupChange && containsTag === DEFAULT_SELECT && tageValue === DEFAULT_SELECT ) || 
           (containsChange && tageValue !== DEFAULT_SELECT && (workgroupChange || tagChange));
        setButtonDisable(!shouldEnableButton);
    }, [validation]);

    const updateValidationState = (value: string, key: string) => {
        setValidation({
            ...validation,
            [key]: value !== DEFAULT_SELECT,
        });
    };

    const resetButtonState = () => {
        setValidation(INITIAL_VALIDATION_VALUES);
        setButtonDisable(true);
    };

    return {
        isButtonDisable,
        resetButtonState,
    };
};

export default useWorkgroupSearchFormValidation;